<template>
  <div id="app" class="page" :class="brandClass()">
    <div id="global-loader-overlay">
      <object id="global-loader-darkmode" type="image/svg+xml" :data="basePath+'/bmw-loading-white.svg'"></object>
      <object id="global-loader" type="image/svg+xml" :data="basePath+'/bmw-loading-dark.svg'"></object>
      <div id="global-loader-two">
        <div class="box" id="lg-mini">
          <div class="custom-loader mini"></div>
        </div>
      </div>
      <div id="global-loader-three">
        <div class="spinner mod-global section-portal realm-2">
          <div class="spinner-icon">
            <svg class="spinner-icon-svg" width="100%" height="100%" viewBox="-10 -10 120 120">
                <path d="M0 50A50 50 0 1 1 50 100" fill="transparent" stroke-width="10"></path>
            </svg>
          </div>
        </div>
      </div>
      <div id="global-loader-four">
        <div class="box" id="lg-rr">
          <div class="custom-loader rr"></div>
        </div>
      </div>
      <div id="global-loader-five">
        <div class="box" id="lg-alphabet">
          <div class="custom-loader alphabet"></div>
        </div>
      </div>
    </div>
    <div class="full-width-page">
      <div class="full-page">
        <Message />
        <!--        <div id="loader-overlay" class="loader-overlay">-->
        <!--          <img id="loader" src="@/assets/loader.gif" class="loader"/>-->
        <!--        </div>-->
        <div class="wrapper">
          <Profile />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Message from "@/components/Message";

import Profile from "@/views/Profile";
import oneUtils from "../gcdm-one-library/gcdm-one-utils/src/bootstrap";
import useVuelidate from '@vuelidate/core'
import { defineComponent } from 'vue';


export default defineComponent({
  setup(props) {
    return { v$: useVuelidate() }
  },
  inject:['$c', '$t', 'brandClass', 'assetSource'],
  mixins: [oneUtils.queryInterceptorMixin, oneUtils.accessibilityMixin],
  components: { Message, Profile },
  watch: {
     currentConfiguration: {
      deep: true,
      handler() {
        oneUtils.sessionUtils.updateFavicon(this.assetSource(this.$c("image_for_favicon")));
      },
    },
  },
  computed: {
    currentConfiguration() {
      return this.$store.getters.getConfigurationParams;
    },
    brand() {
      return (
        this.$store.state.configurationParams.brand ||
        oneUtils.properties.DEFAULT_FALLBACK_BRAND
      );
    },
  },
  mounted:function(){
    //disable console log by environment
    oneUtils.utils.hideConsoleLogInByEnvironment();
    //store originalUrl in order to track it
    this.$store.dispatch('setupOriginalUrl',window.location.href);
    const brand=window['$startupwebcomponent'].oneid_brand;

    const params = this.getQueryParams(location.href);
    const darkmode = this.getDarkmode(params);

    if(brand=="mini"){
        document.getElementById('global-loader-two').style.display='block';
    }else if(brand=="toyota"){
        document.getElementById('global-loader-three').style.display='block';
    }else if(brand=="rr"){
        document.getElementById('global-loader-four').style.display='block';
    }else if(brand=="alphabet"){
        document.getElementById('global-loader-five').style.display='block';
    }else{
      if(darkmode) {
          document.getElementById('global-loader-darkmode').style.display='block';
      }
      else {
          document.getElementById('global-loader').style.display='block';
      }
    }
  },
  beforeCreate() {
    //to catch webkit autofill animation
    document.addEventListener("mousemove", (e) => {
      e.stopPropagation();
    });
  },
  methods: {
    getQueryParams(url) {
      const queryParams = {};
      if (url.indexOf("?") >= 0) {
        const params = url.substr(url.indexOf("?") + 1).split("&");
        for (var i = 0; i < params.length; i++ ) {
          const elem = params[i];
          const pair = elem.split("=");
          let toAdd = "";
          if(pair.length>2){
            for (let index = 2; index < pair.length; index++) {
              const element = '='+pair[index];
              toAdd = toAdd+element;
            }
          }
          queryParams[pair[0]] = decodeURIComponent(pair[1])
            ? decodeURIComponent(pair[1])+toAdd
            : "";
        }
      }
      return queryParams;
    },
    getDarkmode(params){
      if(params){
        return (params.isDarkmode && params.isDarkmode=="true") || (params.isDarkmode!="false" && window.localStorage.getItem("oneid_darkmode_selected_")=="true");   
      }else{
        return window.localStorage.getItem("oneid_darkmode_selected_"+params.brand)=="true"; 
      }
    }
  }
});
</script>

<style lang="scss">
@keyframes  rotate{to{transform:rotate3d(0,0,1,360deg)}}@-webkit-keyframes rotate{to{-webkit-transform:rotate3d(0,0,1,360deg)}}#global-loader-overlay{position:absolute;width:100%;height:300vh;background-color:#fff;z-index:999;box-sizing:initial;}#global-loader{position:fixed;top:calc(50vh - 26px);left:calc(50vw - 26px);width:52px;height:52px;display:none}#global-loader-darkmode{position:fixed;top:calc(50vh - 26px);left:calc(50vw - 26px);width:52px;height:52px;display:none}#global-loader-three{display:none}#global-loader-four,#global-loader-five,#global-loader-two{position:fixed;top:calc(50vh);left:calc(50vw);display:none;transform:translate3d(-50%,-50%,0)}.box{display:flex;justify-content:center;align-items:center;}.custom-loader{flex:0 1 auto;border-radius:50%;border-style:solid;border-top-color:transparent;animation:rotate 1s linear infinite;-webkit-animation:rotate 1s linear infinite;height:33px;width:33px;border-width:3px}.custom-loader.mini{border-color:#4a4a4a;border-top-color:transparent}.custom-loader.rr{border-color:#6FDBC7;border-top-color:transparent}.custom-loader.alphabet{border:5px solid #FFF;border-color:#00D7E7;border-bottom-color:#FF6D6A}@media screen and (max-width:768px){#global-loader{top:calc(50vh - 20px);left:calc(50vw - 20px);width:40px;height:40px}}#not-supported-browser{display:none;text-align:center;position:absolute;z-index:1000;top:100px;margin:0 auto;left:0;right:0}.spinner{position:absolute;top:0;right:0;bottom:0;left:0;z-index:10}.section-cockpit.spinner .mod-invisible-background{background-color:rgba(0,0,0,0)}.section-portal.spinner .mod-invisible-background{background-color:rgba(0,0,0,0)}.spinner-icon{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:40px;;height:40px;}.spinner-text{position:absolute;top:50%;text-align:center;width:100%;margin-top:40px;font-size:larger;animation:spinner-text-animation 2s infinite alternate}@keyframes spinner-text-animation{from{color:#000}to{color:#fff}}.spinner-icon-svg{fill:transparent;animation:1s cubic-bezier(.1,.5,.9,.5) infinite spinner;width:100%;height:100%;stroke-width:10}@keyframes spinner{from{transform:rotate(0)}to{transform:rotate(360deg)}}.spinner.mod-global{position:fixed;top:0;bottom:0;left:0;right:0}.spinner.is-disabled{display:none}.u-spinner-host{position:relative;min-height:60px}.spinner{background-color:rgba(255,255,255,.75)}.spinner-icon-svg{stroke:#C00}

@import "@/styles/_generalStyle.scss";
@import "@/styles/_darkmode.scss";


</style>
